module.exports = __webpack_public_path__ + "static/christianwork3-b46d7bf88c1fd8b945ec103a057d7036.jpg";